import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function Header() {
  const authContext = useContext(AuthContext);
  const user = authContext?.user;
  const logout = authContext?.logout;
  
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [show2025, setShow2025] = useState(false);
  const [show2026, setShow2026] = useState(true);

  const handleLogout = () => {
    if (logout) {
      logout();
      navigate('/login');
      setIsMenuOpen(false);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleChatClick = (e) => {
    e.preventDefault();
    
    if (window.location.pathname === '/2025/leaderboard' || window.location.pathname === '/2026/leaderboard') {
      const commentsSection = document.getElementById('comments-section');
      if (commentsSection) {
        commentsSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = '/2026/leaderboard#comments';
    }
    
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-transparent text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="text-xl font-bold">F1 Predictor</Link>
        
        {/* Hamburger button - only visible on mobile */}
        <button 
          onClick={toggleMenu}
          className="md:hidden flex flex-col justify-center items-center w-8 h-8 space-y-1"
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block w-6 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
        </button>
        
        {/* Desktop navigation - hidden on mobile */}
        <nav className="hidden md:block">
          <ul className="flex space-x-4 list-none items-center flex-wrap">
            <li><Link to="/" className="text-white hover:text-gray-300">Home</Link></li>
            
            {/* 2025 Season Dropdown */}
            <li className="relative group">
              <button className="text-white hover:text-gray-300 py-2 flex items-center">
                2025 Season
                <span className="ml-1">▼</span>
              </button>
              <div className="absolute left-0 mt-0 w-48 bg-gray-700 text-white rounded shadow-lg hidden group-hover:block z-50">
                <Link to="/2025/leaderboard" className="block px-4 py-2 hover:bg-gray-600 rounded-t">Leaderboard</Link>
              </div>
            </li>

            {/* 2026 Season Dropdown */}
            <li className="relative group">
              <button className="text-white hover:text-gray-300 py-2 flex items-center bg-blue-600 hover:bg-blue-700 px-2 rounded">
                2026 Season ✨
                <span className="ml-1">▼</span>
              </button>
              <div className="absolute left-0 mt-0 w-48 bg-gray-700 text-white rounded shadow-lg hidden group-hover:block z-50">
                <Link to="/2026/predictions" className="block px-4 py-2 hover:bg-gray-600 rounded-t">Predictions</Link>
                <Link to="/2026/leaderboard" className="block px-4 py-2 hover:bg-gray-600">Leaderboard</Link>
                <Link to="/2026/results" className="block px-4 py-2 hover:bg-gray-600">Results</Link>
                <Link to="/2026/stats" className="block px-4 py-2 hover:bg-gray-600 rounded-b">Statistics</Link>
              </div>
            </li>
            
            <li><Link to="/roadmap" className="text-white hover:text-gray-300">Roadmap</Link></li>
            <li>
              <a 
                href="#comments"
                onClick={handleChatClick}
                className="text-white hover:text-gray-300 cursor-pointer"
              >
                Chat
              </a>
            </li>
            
            {user ? (
              <>
                <li className="text-white bg-gray-700 px-3 py-1 rounded">Welcome, {user.username}</li>
                <li>
                  <button 
                    onClick={handleLogout}
                    className="text-white hover:text-gray-300 bg-red-600 hover:bg-red-700 px-3 py-1 rounded transition-colors"
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
                <li><Link to="/login" className="text-white hover:text-gray-300">Login</Link></li>
                <li><Link to="/register" className="text-white hover:text-gray-300">Register</Link></li>
              </>
            )}
          </ul>
        </nav>
      </div>
      
      {/* Mobile navigation menu - slides down when hamburger is clicked */}
      <div className={`md:hidden transition-all duration-300 ease-in-out ${isMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
        <div className="bg-gray-800 mt-4 border-t border-gray-700 pt-4 pb-6">
          <ul className="flex flex-col space-y-3 list-none">
            <li><Link to="/" onClick={closeMenu} className="block text-white hover:text-gray-300 py-2">Home</Link></li>
            
            {/* Mobile 2025 Season Section */}
            <li className="border-t border-gray-700 pt-3 mt-2">
              <button 
                onClick={() => setShow2025(!show2025)}
                className="w-full text-left text-white hover:text-gray-300 py-2 font-semibold flex justify-between items-center"
              >
                2025 Season
                <span>{show2025 ? '▲' : '▼'}</span>
              </button>
              {show2025 && (
                <div className="pl-4 space-y-2 mt-2">
                  <Link to="/2025/leaderboard" onClick={closeMenu} className="block text-gray-300 hover:text-white py-2">Leaderboard</Link>
                </div>
              )}
            </li>

            {/* Mobile 2026 Season Section */}
            <li className="border-t border-gray-700 pt-3 mt-2">
              <button 
                onClick={() => setShow2026(!show2026)}
                className="w-full text-left text-white hover:text-gray-300 py-2 font-semibold flex justify-between items-center bg-blue-600 hover:bg-blue-700 px-2 rounded"
              >
                2026 Season ✨
                <span>{show2026 ? '▲' : '▼'}</span>
              </button>
              {show2026 && (
                <div className="pl-4 space-y-2 mt-2">
                  <Link to="/2026/predictions" onClick={closeMenu} className="block text-gray-300 hover:text-white py-2">Predictions</Link>
                  <Link to="/2026/leaderboard" onClick={closeMenu} className="block text-gray-300 hover:text-white py-2">Leaderboard</Link>
                  <Link to="/2026/results" onClick={closeMenu} className="block text-gray-300 hover:text-white py-2">Results</Link>
                  <Link to="/2026/stats" onClick={closeMenu} className="block text-gray-300 hover:text-white py-2">Statistics</Link>
                </div>
              )}
            </li>
            
            <li className="border-t border-gray-700 pt-3 mt-2">
              <Link to="/roadmap" onClick={closeMenu} className="block text-white hover:text-gray-300 py-2">Roadmap</Link>
            </li>
            <li>
              <a 
                href="#comments"
                onClick={handleChatClick}
                className="block text-white hover:text-gray-300 py-2 cursor-pointer"
              >
                Chat
              </a>
            </li>
            
            {user ? (
              <>
                <li className="text-white py-2 border-t border-gray-700 pt-3 mt-2">Welcome, {user.username}</li>
                <li className="pb-2">
                  <button 
                    onClick={handleLogout}
                    className="w-full text-left text-white bg-red-600 hover:bg-red-700 py-3 px-4 rounded transition-colors border-0 outline-none font-medium"
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
                <li className="border-t border-gray-700 pt-3 mt-2">
                  <Link to="/login" onClick={closeMenu} className="block text-white hover:text-gray-300 py-2">Login</Link>
                </li>
                <li>
                  <Link to="/register" onClick={closeMenu} className="block text-white hover:text-gray-300 py-2">Register</Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;